__turbopack_context__.v({
  "container": "qxQiBW_container",
  "message": "qxQiBW_message",
});
